const onload = function(justify_scale, item, width, height){
  let ratio = width / height;
  item.style.width = justify_scale * ratio + 'px';
  item.style.flexGrow = ratio;
}

let timeout, windowWidth = window.innerWidth;

function resize() {
  clearTimeout(timeout)
  if(windowWidth !== window.innerWidth){
    timeout = setTimeout(init, 500)
  }
}

const init = function () {
  //Justify Gallery
  const justify_scale = window.innerHeight * 0.2;

  let items = document.querySelectorAll('.gallery > a');

  items.forEach(function (item) {
    let width = Number(item.getAttribute('data-width'))
    let height = Number(item.getAttribute('data-height'))
    onload(justify_scale, item, width, height)
  })
}
/**
 * https://codepen.io/allardyce/pen/YjvKpV?page=1&
 */
export default function () {
  //Justify Gallery
  init()
  on(window, 'resize', resize)
}
